// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2113f","delete":"styles_delete__G1c8v","update":"styles_update__1DO9G","add":"styles_add__ENiio"};